import siteConfig from "../data/site-config.json";

export const SITE_URL = siteConfig.siteUrl.replace(/\/+$/, "");
export const SITE_NAME = siteConfig.siteName;
export const SITE_LOGO = new URL(siteConfig.siteLogoPath, `${SITE_URL}/`).toString();

export function normalizePathname(pathname = "/") {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "") || "/";
}

export function buildCanonicalUrl(pathname = "/") {
  const normalizedPathname = normalizePathname(pathname);
  return normalizedPathname === "/" ? `${SITE_URL}/` : `${SITE_URL}${normalizedPathname}/`;
}

export function resolveImageUrl(imagePath) {
  if (!imagePath) {
    return SITE_LOGO;
  }

  return imagePath.startsWith("http")
    ? imagePath
    : new URL(imagePath, `${SITE_URL}/`).toString();
}

export function createBreadcrumbSchema(pathname, title) {
  const normalizedPathname = normalizePathname(pathname);

  if (normalizedPathname === "/") {
    return null;
  }

  const segments = normalizedPathname.split("/").filter(Boolean);
  const items = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${SITE_URL}/`,
    },
  ];

  let currentPath = "";

  segments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === segments.length - 1;
    const label = isLast
      ? title.replace(/\s+\|\s+PSP RCM.*$/, "")
      : segment.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

    items.push({
      "@type": "ListItem",
      position: index + 2,
      name: label,
      item: buildCanonicalUrl(currentPath),
    });
  });

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items,
  };
}

export function createWebPageSchema({ path, title, description, type = "WebPage" }) {
  return {
    "@context": "https://schema.org",
    "@type": type,
    name: title.replace(/\s+\|\s+PSP RCM.*$/, ""),
    url: buildCanonicalUrl(path),
    description,
    isPartOf: {
      "@type": "WebSite",
      name: SITE_NAME,
      url: `${SITE_URL}/`,
    },
    about: {
      "@type": "Organization",
      name: SITE_NAME,
      url: `${SITE_URL}/`,
    },
  };
}
